import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { tk } from '@/i18n/translationKeys';
import { Button } from '@devsbb/ui';
import { TrackYourPaymentsEvents } from '@/analytics';
import { useApplicationData } from '@/providers/applicationData';
import { useScreenMatch } from '@/hooks/useScreenMatch';
import { WalletIcon } from '@/icons/WalletIcon';

export const LinkToPaymentMethods = () => {
  const { userId, storeCode, routeBuilder } = useApplicationData();
  const { t } = useTranslation();
  const { isMobile } = useScreenMatch();

  const handleClick = useCallback(() => {
    TrackYourPaymentsEvents.paymentMethodsLinkClick({
      userId,
      store: storeCode,
    });

    window.location.href = routeBuilder.buildPaymentMethodListRoute();
  }, [storeCode]);

  return (
    <Button
      onClick={handleClick}
      iconOnly={isMobile}
      size="S"
      variant={isMobile ? 'Ghost' : 'Grey'}
      testId="your-payments-manage-payment-methods-button"
      aria-label={t(tk.yourPaymentsLinkToPaymentMethodsText)}
    >
      <WalletIcon />
      {!isMobile && t(tk.yourPaymentsLinkToPaymentMethodsText)}
    </Button>
  );
};
